import { defineMessages } from 'react-intl';

export default defineMessages({
    lblTdosTitle: {
        id: 'app.common.ticketDeliveryDetails.tdosTitle',
        defaultMessage: 'Tickets can be retrieved via any of the following methods:',
    },
});
